// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"443":"about","571":"settings"}[chunkId] || chunkId) + "." + {"304":"d1509fc9","443":"b01feeb7","571":"e2e8dd14","657":"b36419e4","922":"46df6eb8"}[chunkId] + ".js";
};